var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableWithPagination',{attrs:{"tableData":_vm.targetLists,"columnList":_vm.columnList,"max-height":"400px","pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event},"current-change":_vm.getTargetLists,"sort-change":_vm.getTargetLists}})
}
var staticRenderFns = []

export { render, staticRenderFns }